import {createActions} from 'client/framework';

export default createActions(null, [
  'SET_ABANDON_CHANGES_HANDLER',
  'ABANDON_CHANGES',
  'RESET_STORE'
]);
